
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexhgxX3FuNKv4h9Fl1XNh1mP0Q66Qs4VCSLVW_459BsEnV8Meta } from "/portal/pages/index.vue?macro=true";
import { default as _91course_930kTE2WH7BtwTwtRCdmyyLSVx7FRTciSbl9DAvbgJnN4Meta } from "/portal/pages/[course].vue?macro=true";
import { default as maintenancelIpKxUcc6ty_exveBdBJ_9RLMh_45YJtar5oDkn7lX7CAMeta } from "/portal/pages/maintenance.vue?macro=true";
import { default as indexXeh9A3NBbb3xqGi_45v_R2py_45EmmQu_L2slCCQan8QOCEMeta } from "/portal/pages/vagas/index.vue?macro=true";
import { default as _91id_93WB01C7Gr9BxiqQIJsnMjhj93pCfAqvMrydye1UaxXA0Meta } from "/portal/pages/preview/[id].vue?macro=true";
import { default as indexNEJsilKY8J8xiTw5a2gYiRyLXnm0rxZdqMMEMoJrebQMeta } from "/portal/pages/mestrado/index.vue?macro=true";
import { default as index2jWcmRIN65fnnV7Far9pNSJ2sQejBDRFq_45oCYRlSoJIMeta } from "/portal/pages/noticias/index.vue?macro=true";
import { default as _91id_93qf7sqU5F3XwyHbhGGbXGnJvGoMy6UXjVpCHjYRpSFRMMeta } from "/portal/pages/vagas/uno/[id].vue?macro=true";
import { default as indextyUAoAW5h4V5yYMGCZtZt1NtJkyN5Uo8X3vllhX6XjkMeta } from "/portal/pages/graduacao/index.vue?macro=true";
import { default as _91slug_93SO97CyjajaLtxUtbIxB3Eu42_45zaG5GEJNm5qq6aTVrsMeta } from "/portal/pages/noticias/[slug].vue?macro=true";
import { default as _91course_93pJHlWqRVDrxPHRmgoYWDxaXY0Ff3ILImHGpVWF6tUYUMeta } from "/portal/pages/escolas/[course].vue?macro=true";
import { default as _91course_93sV7NyIL9AGIJNfO7uIIQNp0WVjUlkNgIN1NdTzOn2y8Meta } from "/portal/pages/mestrado/[course].vue?macro=true";
import { default as _91course_93NmZ_45x4S17CPoqqnv5YwpRDN_g6kUv1DtlVrAhADwHCgMeta } from "/portal/pages/graduacao/[course].vue?macro=true";
import { default as inscricaowIdVjUYLFdDAXzef_nq3Kf34mg0mXX_dZyYNM9_SJU0Meta } from "/portal/pages/minhauno/inscricao.vue?macro=true";
import { default as indexSV7kn6h57K2sU_lWxRYKYtV7aPCszyhsyhPvq5TXZhEMeta } from "/portal/pages/institucional/index.vue?macro=true";
import { default as index2AaVk6PNxVdXpMszYiQjNxWElWJDDCtNfRZRHxNukusMeta } from "/portal/pages/especializacao/index.vue?macro=true";
import { default as _91course_934_wVocE7ZLFojclgGAQA9e9obpJq9EfnCdTIz4k9n1sMeta } from "/portal/pages/institucional/[course].vue?macro=true";
import { default as _91course_93Z6giZ4KxqktzimtKcwv_BLIPmnYCTFya3CHzVXsYr_4Meta } from "/portal/pages/especializacao/[course].vue?macro=true";
import { default as _91title_93mBeaKtPMj63NgS3ltucJYE_45witWkENcoBHsfe0GXWzIMeta } from "/portal/pages/vagas/uno/interno/[title].vue?macro=true";
import { default as component_45stubrs2OEpd37pw3dSHQrfUp_45XL_6v9uqbUt1svb_45Y7_tLYMeta } from "/portal/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubrs2OEpd37pw3dSHQrfUp_45XL_6v9uqbUt1svb_45Y7_tLY } from "/portal/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index___pt-BR___default",
    path: "/",
    component: () => import("/portal/pages/index.vue")
  },
  {
    name: "index___pt-BR",
    path: "/pt-BR",
    component: () => import("/portal/pages/index.vue")
  },
  {
    name: "index___en-US",
    path: "/en-US",
    component: () => import("/portal/pages/index.vue")
  },
  {
    name: "index___es-ES",
    path: "/es-ES",
    component: () => import("/portal/pages/index.vue")
  },
  {
    name: "course___pt-BR___default",
    path: "/:course()",
    component: () => import("/portal/pages/[course].vue")
  },
  {
    name: "course___pt-BR",
    path: "/pt-BR/:course()",
    component: () => import("/portal/pages/[course].vue")
  },
  {
    name: "course___en-US",
    path: "/en-US/:course()",
    component: () => import("/portal/pages/[course].vue")
  },
  {
    name: "course___es-ES",
    path: "/es-ES/:course()",
    component: () => import("/portal/pages/[course].vue")
  },
  {
    name: "maintenance___pt-BR___default",
    path: "/maintenance",
    component: () => import("/portal/pages/maintenance.vue")
  },
  {
    name: "maintenance___pt-BR",
    path: "/pt-BR/maintenance",
    component: () => import("/portal/pages/maintenance.vue")
  },
  {
    name: "maintenance___en-US",
    path: "/en-US/maintenance",
    component: () => import("/portal/pages/maintenance.vue")
  },
  {
    name: "maintenance___es-ES",
    path: "/es-ES/maintenance",
    component: () => import("/portal/pages/maintenance.vue")
  },
  {
    name: "vagas___pt-BR___default",
    path: "/vagas",
    component: () => import("/portal/pages/vagas/index.vue")
  },
  {
    name: "vagas___pt-BR",
    path: "/pt-BR/vagas",
    component: () => import("/portal/pages/vagas/index.vue")
  },
  {
    name: "vagas___en-US",
    path: "/en-US/vagas",
    component: () => import("/portal/pages/vagas/index.vue")
  },
  {
    name: "vagas___es-ES",
    path: "/es-ES/vagas",
    component: () => import("/portal/pages/vagas/index.vue")
  },
  {
    name: "preview-id___pt-BR___default",
    path: "/preview/:id()",
    component: () => import("/portal/pages/preview/[id].vue")
  },
  {
    name: "preview-id___pt-BR",
    path: "/pt-BR/preview/:id()",
    component: () => import("/portal/pages/preview/[id].vue")
  },
  {
    name: "preview-id___en-US",
    path: "/en-US/preview/:id()",
    component: () => import("/portal/pages/preview/[id].vue")
  },
  {
    name: "preview-id___es-ES",
    path: "/es-ES/preview/:id()",
    component: () => import("/portal/pages/preview/[id].vue")
  },
  {
    name: "mestrado___pt-BR___default",
    path: "/mestrado",
    component: () => import("/portal/pages/mestrado/index.vue")
  },
  {
    name: "mestrado___pt-BR",
    path: "/pt-BR/mestrado",
    component: () => import("/portal/pages/mestrado/index.vue")
  },
  {
    name: "mestrado___en-US",
    path: "/en-US/mestrado",
    component: () => import("/portal/pages/mestrado/index.vue")
  },
  {
    name: "mestrado___es-ES",
    path: "/es-ES/mestrado",
    component: () => import("/portal/pages/mestrado/index.vue")
  },
  {
    name: "noticias___pt-BR___default",
    path: "/noticias",
    component: () => import("/portal/pages/noticias/index.vue")
  },
  {
    name: "noticias___pt-BR",
    path: "/pt-BR/noticias",
    component: () => import("/portal/pages/noticias/index.vue")
  },
  {
    name: "noticias___en-US",
    path: "/en-US/noticias",
    component: () => import("/portal/pages/noticias/index.vue")
  },
  {
    name: "noticias___es-ES",
    path: "/es-ES/noticias",
    component: () => import("/portal/pages/noticias/index.vue")
  },
  {
    name: "vagas-uno-id___pt-BR___default",
    path: "/vagas/uno/:id()",
    component: () => import("/portal/pages/vagas/uno/[id].vue")
  },
  {
    name: "vagas-uno-id___pt-BR",
    path: "/pt-BR/vagas/uno/:id()",
    component: () => import("/portal/pages/vagas/uno/[id].vue")
  },
  {
    name: "vagas-uno-id___en-US",
    path: "/en-US/vagas/uno/:id()",
    component: () => import("/portal/pages/vagas/uno/[id].vue")
  },
  {
    name: "vagas-uno-id___es-ES",
    path: "/es-ES/vagas/uno/:id()",
    component: () => import("/portal/pages/vagas/uno/[id].vue")
  },
  {
    name: "graduacao___pt-BR___default",
    path: "/graduacao",
    component: () => import("/portal/pages/graduacao/index.vue")
  },
  {
    name: "graduacao___pt-BR",
    path: "/pt-BR/graduacao",
    component: () => import("/portal/pages/graduacao/index.vue")
  },
  {
    name: "graduacao___en-US",
    path: "/en-US/graduacao",
    component: () => import("/portal/pages/graduacao/index.vue")
  },
  {
    name: "graduacao___es-ES",
    path: "/es-ES/graduacao",
    component: () => import("/portal/pages/graduacao/index.vue")
  },
  {
    name: "noticias-slug___pt-BR___default",
    path: "/noticias/:slug()",
    component: () => import("/portal/pages/noticias/[slug].vue")
  },
  {
    name: "noticias-slug___pt-BR",
    path: "/pt-BR/noticias/:slug()",
    component: () => import("/portal/pages/noticias/[slug].vue")
  },
  {
    name: "noticias-slug___en-US",
    path: "/en-US/noticias/:slug()",
    component: () => import("/portal/pages/noticias/[slug].vue")
  },
  {
    name: "noticias-slug___es-ES",
    path: "/es-ES/noticias/:slug()",
    component: () => import("/portal/pages/noticias/[slug].vue")
  },
  {
    name: "escolas-course___pt-BR___default",
    path: "/escolas/:course()",
    component: () => import("/portal/pages/escolas/[course].vue")
  },
  {
    name: "escolas-course___pt-BR",
    path: "/pt-BR/escolas/:course()",
    component: () => import("/portal/pages/escolas/[course].vue")
  },
  {
    name: "escolas-course___en-US",
    path: "/en-US/escolas/:course()",
    component: () => import("/portal/pages/escolas/[course].vue")
  },
  {
    name: "escolas-course___es-ES",
    path: "/es-ES/escolas/:course()",
    component: () => import("/portal/pages/escolas/[course].vue")
  },
  {
    name: "mestrado-course___pt-BR___default",
    path: "/mestrado/:course()",
    component: () => import("/portal/pages/mestrado/[course].vue")
  },
  {
    name: "mestrado-course___pt-BR",
    path: "/pt-BR/mestrado/:course()",
    component: () => import("/portal/pages/mestrado/[course].vue")
  },
  {
    name: "mestrado-course___en-US",
    path: "/en-US/mestrado/:course()",
    component: () => import("/portal/pages/mestrado/[course].vue")
  },
  {
    name: "mestrado-course___es-ES",
    path: "/es-ES/mestrado/:course()",
    component: () => import("/portal/pages/mestrado/[course].vue")
  },
  {
    name: "graduacao-course___pt-BR___default",
    path: "/graduacao/:course()",
    component: () => import("/portal/pages/graduacao/[course].vue")
  },
  {
    name: "graduacao-course___pt-BR",
    path: "/pt-BR/graduacao/:course()",
    component: () => import("/portal/pages/graduacao/[course].vue")
  },
  {
    name: "graduacao-course___en-US",
    path: "/en-US/graduacao/:course()",
    component: () => import("/portal/pages/graduacao/[course].vue")
  },
  {
    name: "graduacao-course___es-ES",
    path: "/es-ES/graduacao/:course()",
    component: () => import("/portal/pages/graduacao/[course].vue")
  },
  {
    name: "minhauno-inscricao___pt-BR___default",
    path: "/minhauno/inscricao",
    component: () => import("/portal/pages/minhauno/inscricao.vue")
  },
  {
    name: "minhauno-inscricao___pt-BR",
    path: "/pt-BR/minhauno/inscricao",
    component: () => import("/portal/pages/minhauno/inscricao.vue")
  },
  {
    name: "minhauno-inscricao___en-US",
    path: "/en-US/minhauno/inscricao",
    component: () => import("/portal/pages/minhauno/inscricao.vue")
  },
  {
    name: "minhauno-inscricao___es-ES",
    path: "/es-ES/minhauno/inscricao",
    component: () => import("/portal/pages/minhauno/inscricao.vue")
  },
  {
    name: "institucional___pt-BR___default",
    path: "/institucional",
    component: () => import("/portal/pages/institucional/index.vue")
  },
  {
    name: "institucional___pt-BR",
    path: "/pt-BR/institucional",
    component: () => import("/portal/pages/institucional/index.vue")
  },
  {
    name: "institucional___en-US",
    path: "/en-US/institucional",
    component: () => import("/portal/pages/institucional/index.vue")
  },
  {
    name: "institucional___es-ES",
    path: "/es-ES/institucional",
    component: () => import("/portal/pages/institucional/index.vue")
  },
  {
    name: "especializacao___pt-BR___default",
    path: "/especializacao",
    component: () => import("/portal/pages/especializacao/index.vue")
  },
  {
    name: "especializacao___pt-BR",
    path: "/pt-BR/especializacao",
    component: () => import("/portal/pages/especializacao/index.vue")
  },
  {
    name: "especializacao___en-US",
    path: "/en-US/especializacao",
    component: () => import("/portal/pages/especializacao/index.vue")
  },
  {
    name: "especializacao___es-ES",
    path: "/es-ES/especializacao",
    component: () => import("/portal/pages/especializacao/index.vue")
  },
  {
    name: "institucional-course___pt-BR___default",
    path: "/institucional/:course()",
    component: () => import("/portal/pages/institucional/[course].vue")
  },
  {
    name: "institucional-course___pt-BR",
    path: "/pt-BR/institucional/:course()",
    component: () => import("/portal/pages/institucional/[course].vue")
  },
  {
    name: "institucional-course___en-US",
    path: "/en-US/institucional/:course()",
    component: () => import("/portal/pages/institucional/[course].vue")
  },
  {
    name: "institucional-course___es-ES",
    path: "/es-ES/institucional/:course()",
    component: () => import("/portal/pages/institucional/[course].vue")
  },
  {
    name: "especializacao-course___pt-BR___default",
    path: "/especializacao/:course()",
    component: () => import("/portal/pages/especializacao/[course].vue")
  },
  {
    name: "especializacao-course___pt-BR",
    path: "/pt-BR/especializacao/:course()",
    component: () => import("/portal/pages/especializacao/[course].vue")
  },
  {
    name: "especializacao-course___en-US",
    path: "/en-US/especializacao/:course()",
    component: () => import("/portal/pages/especializacao/[course].vue")
  },
  {
    name: "especializacao-course___es-ES",
    path: "/es-ES/especializacao/:course()",
    component: () => import("/portal/pages/especializacao/[course].vue")
  },
  {
    name: "vagas-uno-interno-title___pt-BR___default",
    path: "/vagas/uno/interno/:title()",
    component: () => import("/portal/pages/vagas/uno/interno/[title].vue")
  },
  {
    name: "vagas-uno-interno-title___pt-BR",
    path: "/pt-BR/vagas/uno/interno/:title()",
    component: () => import("/portal/pages/vagas/uno/interno/[title].vue")
  },
  {
    name: "vagas-uno-interno-title___en-US",
    path: "/en-US/vagas/uno/interno/:title()",
    component: () => import("/portal/pages/vagas/uno/interno/[title].vue")
  },
  {
    name: "vagas-uno-interno-title___es-ES",
    path: "/es-ES/vagas/uno/interno/:title()",
    component: () => import("/portal/pages/vagas/uno/interno/[title].vue")
  },
  {
    name: component_45stubrs2OEpd37pw3dSHQrfUp_45XL_6v9uqbUt1svb_45Y7_tLYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubrs2OEpd37pw3dSHQrfUp_45XL_6v9uqbUt1svb_45Y7_tLY
  }
]